import { createStore } from 'vuex';
import { setLocale as veeValidateSetLocale } from '@vee-validate/i18n';


// The Vuex store serves a similar role to SessionResources in our other projects.
// Documentation available here. https://next.vuex.vuejs.org/

export default createStore({
    //Variable declaration
    state: {
        actionCompleted: null,
        link: null,
        locale: 'en',
        trip: null
    },

    //Getters - these behave similarly to computed properties on Vue components.
    //NOTE: not cached like a computed property. This issue to be resolved in Vue 3.1
    getters: {

    },

    //Mutations are synchronous setters for state variables.
    //Invoke in a component with this.$store.commit('mutationFunctionName', optionalPayload);
    mutations: {

        setActionCompleted(state, actionCompleted) {
            state.actionCompleted = actionCompleted;
        },

        /**
         * Completely replace the active link in the store.
         * @param state
         * @param link
         */
        setLink(state, link) {
            state.link = link;
        },

        initializeLocale(state) {
            let locale = localStorage.getItem('locale');
            if (locale) {
                state.locale = locale;
                veeValidateSetLocale(locale);
            }
        },

        setLocale(state, locale) {
            state.locale = locale;
            localStorage.setItem('locale', locale);
            veeValidateSetLocale(locale);
        },

        /**
         * Completely replace the active trip in the store.
         * @param state
         * @param trip
         */
        setTrip(state, trip) {
            state.trip = trip;
        }
    },


    //Actions are asynchronous setters for state variables. Can call other getters & mutations.
    //Invoke in a component with this.$store.dispatch('actionFunctionName', optionalPayload);
    actions: {

    }
})
